import React, {useContext} from "react";
import { Context } from "../contextApi/context";
import DashboardManageTable from "./table/DashboardManageTable";

const ManageCanvas = () => {
  const {collapse} = useContext(Context);

  return (<>
    <div>
      <div className={collapse?'content-body':'content-body-collapse'} >
        <div className="container-fluid metadata">
          <DashboardManageTable/>
        </div>
      </div>
    </div>
  </>);
}

export default ManageCanvas;